import { Button, Modal } from 'antd';
import React from 'react'
import { useDeleteUserMutation, useActivateUserMutation } from '../../redux/Api/UserManagment/uMUsersApiSlice';
import { toast } from 'react-toastify';
import Loader from '../../pages/pages/loader';

const DeactivateUser = ({ open, setOpen, user }) => {
    const [deleteUser, { isLoading: isDeleting }] = useDeleteUserMutation()
    const [activateUser, { isLoading: isActivating }] = useActivateUserMutation()
    
    return (
        <Modal
            className='customModal'
            open={open}
            title={"Deactivate User"}
            onCancel={() => setOpen(false)}
            footer={[
                <Button key="back" onClick={() => setOpen(false)}>
                    Cancel
                </Button>,
                <Button key="submit" type="primary" loading={isDeleting || isActivating} onClick={async () => {
                    try {
                        if (user?.is_active === true) {
                            await deleteUser(user?.id).unwrap()
                            toast.success('User deactivated successfully')
                        } else {
                            await activateUser(user?.id).unwrap()
                            toast.success('User activated successfully')
                        }
                        setOpen(false)
                    } catch (error) {
                        if (error?.data) {
                            const errorMessages = Object.values(error.data).flat()
                            errorMessages.forEach(message => {
                                toast.error(message)
                            })
                        } else {
                            toast.error('Failed to update user status')
                        }
                    }
                }}>
                    Submit
                </Button>
            ]}
        >
            <Loader isLoading={isDeleting || isActivating} />
            <p>
                Are you sure you want to {user?.is_active === true ? "Deactivate" : "Activate"} {user?.email}?
            </p>
        </Modal>
    )
}

export default DeactivateUser